type metaType = { alias: string; name: string };

export const meta: metaType = {
  alias: 'poll',
  name: 'Poll'
};
